import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SiteLayout } from "../components/site/SiteLayout";
import { useSeo } from "../lib/seo";

export default function NotFoundPage() {
  useSeo({
    title: "Page Not Found",
    description: "The page you're looking for doesn't exist.",
    path: typeof window !== "undefined" ? window.location.pathname : "/404",
    noindex: true,
  });
  return (
    <SiteLayout>
      <section>
        <div className="container-wald py-28 md:py-40">
          <div className="eyebrow mb-6">404</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-3xl">
            Page not found.
          </h1>
          <p className="mt-6 max-w-xl opacity-80 leading-relaxed text-lg">
            The page you're looking for doesn't exist or has moved.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/" data-testid="404-home-link" className="btn-copper">
              Back to home <ArrowRight size={14} strokeWidth={2} />
            </Link>
            <Link to="/products" data-testid="404-products-link" className="btn-outline">
              View products
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
